"use client";

import "~/components/bloks/defineBloks";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { CentraProvider, useSelection } from "@trydig/centra/client";
import { StoryblokProvider } from "@trydig/storyblok";
import { NextUIProvider } from "@trydig/ui/next";
import { useRouter } from "next/navigation";
import Script from "next/script";
import { useState } from "react";
import { ShowroomModal } from "~/components/ui/ShowroomModal";
import { env } from "~/env";
import { Device } from "~/lib/global/Device";
import { ScrollManager } from "~/lib/global/ScrollManager";

export const RootLayout = ({ children }: Omit<LayoutProps<"/[geo]">, "params">) => {
	const router = useRouter();
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						// Note: option to prevent excessive refetching
						// TODO: Consider setting this option as default in tanstack query configuration
						refetchOnMount: false,
					},
				},
			}),
	);

	const handlePublish = () => {
		router.refresh();
	};

	return (
		<QueryClientProvider client={queryClient}>
			<StoryblokProvider onPublished={handlePublish}>
				<CentraProvider apiUrl={env.NEXT_PUBLIC_CENTRA_CHECKOUT}>
					<NextUIProvider>
						<ScrollManager>
							<Device>
								{children}
								<CentraCheckoutScript />
								<ShowroomModal />
							</Device>
						</ScrollManager>
						<ReactQueryDevtools initialIsOpen={false} />
					</NextUIProvider>
				</CentraProvider>
			</StoryblokProvider>
		</QueryClientProvider>
	);
};

const CentraCheckoutScript = () => {
	const { data } = useSelection();

	if (!data?.selection?.centraCheckoutScript) return null;

	return <Script id="centra-checkout-script">{`${data.selection.centraCheckoutScript}`}</Script>;
};
